
function sendReportingBeacon(sku, type, user, baseUrl = '') {
  if (!sku || !type || !user) {
      console.error('sku, type, and user are required parameters');
      return false;
  }

  const endpoint = `${baseUrl}/ms/v/reporting/`;
  
  const data = JSON.stringify({
      sku: sku,
      type: type,
      user: user
  });

  if (navigator.sendBeacon) {
      const blob = new Blob([data], { type: 'application/json' });
      
      try {
          const success = navigator.sendBeacon(endpoint, blob);
          if (success) {
          } else {
              console.warn('Reporting beacon failed to queue');
          }
          return success;
      } catch (error) {
          console.error('Error sending reporting beacon:', error);
          return false;
      }
  } else {
      console.warn('sendBeacon not supported, falling back to fetch');
      return sendReportingFallback(endpoint, data);
  }
}


function sendReportingFallback(endpoint, data) {
  fetch(endpoint, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: data,
      keepalive: true 
  }).catch(error => {
      console.error('Fallback reporting request failed:', error);
  });
  
  return true;
}


const ReportingBeacon = {

  view: (sku, user, baseUrl) => sendReportingBeacon(sku, 'view', user, baseUrl),

  click: (sku, user, baseUrl) => sendReportingBeacon(sku, 'click', user, baseUrl),
  
  atc: (sku, user, baseUrl) => sendReportingBeacon(sku, 'atc', user, baseUrl),
  
  custom: (sku, type, user, baseUrl) => sendReportingBeacon(sku, type, user, baseUrl)
};



async function loadSessionProducts(reqUrlAddr = 'https://apiapi.ombligo.com/ms/v/product', targetElementId = '#mysessionContent') {
  const customerId = localStorage.getItem('lsid');

  const reqUrl = new URL(reqUrlAddr);

  let randomNumber = Math.floor(Math.random() * 100);
  reqUrl.searchParams.append('user_id', customerId);
  reqUrl.searchParams.append('random', randomNumber);

  if (window.location.search && window.location.search.includes('ref=s')) {
    ReportingBeacon.view(productSKU, customerId, 'https://apiapi.ombligo.com');
    const addToCartButtons = document.querySelectorAll('#AddToCart-product-template');

    addToCartButtons.forEach(button => {

      button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (productSKU) {
        ReportingBeacon.atc(productSKU, customerId, 'https://apiapi.ombligo.com');
      }
      });
    });
  }


  try {
    const response = await fetch(reqUrl);

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();

    const targetElement = document.querySelector(targetElementId);
    if (!targetElement) {
      console.error('Target element #personalRecsContent not found');
      return;
    }



    for (let i = 0; i < data.length; i++) {
      const product = data[i];
      if (!product || !product.sku || !product.handle || !product.title || product.title === '' || product.title === 'null') {
        console.warn('Skipping invalid product:', product);
        continue;
      }

      const productHTML = createProductCard(product);
      const productContainer = document.createElement('div');
      productContainer.className = 'collection_product_card_container recommended-item';
      productContainer.innerHTML = productHTML;

      productContainer.dataset.sku = product.sku;
      productContainer.dataset.handle = product.handle;
      productContainer.dataset.title = product.title;

      productContainer.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const productHandle = this.dataset.handle;
        const ctoHash = product.cto_hash || '';
        if (productHandle) {

          ReportingBeacon.click(product.sku, customerId, 'https://apiapi.ombligo.com');
          if (ctoHash) {
            window.location.href = `/products/${productHandle}/${ctoHash}`;
          } else {
            window.location.href = `/products/${productHandle}?ref=s`;
          }
        }
      }
      );


      const addVariantToCartBtn = productContainer.querySelector('.add-to-cart-btn');
      if (addVariantToCartBtn && !addVariantToCartBtn.disabled) {
        if (addVariantToCartBtn.classList.contains('start_build_btn')) {
          addVariantToCartBtn.addEventListener('click', async function(e) {
            e.preventDefault();
            e.stopPropagation();

            const btnText = this.querySelector('.btn-text');
            const btnSpinner = this.querySelector('.btn-spinner');
            
            btnText.style.display = 'none';
            btnSpinner.style.display = 'inline-block';
            
            this.disabled = true;
            if (product.cto_hash) {
              window.location.href = `/products/${product.handle}/${product.cto_hash}`;
            } else {
              window.location.href = `/products/${product.handle}`;
            }

          });
        } else {
          addVariantToCartBtn.addEventListener('click', async function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            ReportingBeacon.atc(product.sku, customerId, 'https://apiapi.ombligo.com');

            const variantId = this.getAttribute('data-variant-id');
            const productTitle = this.getAttribute('data-product-title');
            const btnText = this.querySelector('.btn-text');
            const btnSpinner = this.querySelector('.btn-spinner');
            
            btnText.style.display = 'none';
            btnSpinner.style.display = 'inline-block';
            this.disabled = true;
            
            try {
              const numericVariantId = variantId.includes('gid://shopify/ProductVariant/') 
                ? variantId.split('/').pop() 
                : variantId;
              
              await addVariantToCart(numericVariantId, 1, productTitle);
              
              
            } catch (error) {
              console.error('Failed to add recommended product to cart:', error);
            } finally {
              btnText.style.display = 'inline-block';
              btnSpinner.style.display = 'none';
              this.disabled = false;
            }
          });
        }
      }

      targetElement.appendChild(productContainer);
    }

    if (data.length > 0) {
      document.querySelector('#mySessionContainer').style.display = 'contents';
    }

  } catch (error) {
    console.error('Error loading recommended products:', error);
  }

  function getCSRFToken() {
    const cookie = document.cookie.match(/csrftoken=([^;]+)/);
    return cookie ? cookie[1] : '';
  }
}